import * as React from 'react';

function composeRefs(...o){return e=>o.forEach((o=>function(o,e){"function"==typeof o?o(e):null!=o&&(o.current=e);}(o,e)))}function useComposedRefs(...e){return React.useCallback(composeRefs(...e),e)}

export { composeRefs, useComposedRefs };
